var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeDotsMob = function SvgThreeDotsMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E4E4",
    d: "M23.297 12.192c-.107 6.24-5.252 11.214-11.492 11.107C5.565 23.193.592 18.05.698 11.808S5.948.594 12.189.7c6.24.106 11.214 5.25 11.108 11.491Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.166 12.442a.72.72 0 1 0 0-1.442.72.72 0 0 0 0 1.442M17.213 12.442a.72.72 0 1 0 0-1.442.72.72 0 0 0 0 1.442M7.12 12.442a.72.72 0 1 0 0-1.442.72.72 0 0 0 0 1.442"
  })));
};
export { SvgThreeDotsMob as ReactComponent };
export default __webpack_public_path__ + "5bf02b948f4a4126b73f698ca127251b.svg";